import { ReactSVG } from 'react-svg';
import Button from '../Button/ButtonComponent';
import InputText from '../InputText/InputTextComponent';
import Popover from '../Popover/PopoverComponent';
import { useRouter } from 'next/router';
import { useRedlMetadata } from 'hooks/useRedlMetadata';
import { useCallback, useMemo, useState } from 'react';
import { dataResources } from '@portal-internet/core';

const { basePath } = dataResources;

export default function MoveComponent({ blocIdx, last }) {
    const router = useRouter();
    const { moveRedlBloc } = useRedlMetadata(router.pathname);
    const [inputValue, setInputValue] = useState('');
    const [isMoveApplied, setIsMoveApplied] = useState(false);

    const onMove = useCallback((blockIdxTo) => {
        moveRedlBloc(blocIdx, blockIdxTo, last);
    }, [blocIdx, last, moveRedlBloc]);

    const handleClick = useCallback(() => {
        const number = Number(inputValue);
        if (!isNaN(number) && inputValue !== '' && inputValue !== null) {
            onMove(Math.min(Math.max(number - 1, 0)));
            setInputValue('');
            setIsMoveApplied(true);
        }
    }, [inputValue, onMove]);

    const handleChange = useCallback((e) => {
        if (!e.target.value) {
            setInputValue('');
        } else {
            const number = Number(e.target.value);
            if (!isNaN(number)) {
                setInputValue(number);
            }
        }
    }, []);

    const handleMoveUp = useCallback(() => {
        onMove(Math.max(blocIdx - 2, 0));
        setInputValue('');
        setIsMoveApplied(true);
    }, [blocIdx, onMove]);
    
    const handleMoveDown = useCallback(() => {
        onMove(Math.min(blocIdx, last));
        setInputValue('');
        setIsMoveApplied(true);
    }, [blocIdx, last, onMove]);

    const trigger = useMemo(() => (
        <>
            <Button
                variant="edit"
                size="sm"
                data-testid={`REDL-move-up-button-${blocIdx}`}
                onClick={handleMoveUp}
            >
                <ReactSVG src={basePath + '/_resources/REDL/icons/arrow-up.svg?v=JIT_ENV_RESOURCES_VERSION'} />
            </Button>

            <Button
                variant="edit"
                size="sm"
                data-testid={`REDL-move-down-button-${blocIdx}`}
                onClick={handleMoveDown}
            >
                <ReactSVG src={basePath + '/_resources/REDL/icons/arrow-down.svg?v=JIT_ENV_RESOURCES_VERSION'} />
            </Button>
        </>
    ), [blocIdx, handleMoveUp, handleMoveDown]);

    const bodyForm = useMemo(() => (
        <>
            <InputText
                value={inputValue}
                setValue={handleChange}
                variant="no-border"
                placeholder="Posició"
                data-testid={`REDL-move-input-${blocIdx}`}
            />
            <Button
                variant="secondary"
                size="sm"
                data-testid={`REDL-move-input-${blocIdx}-button`}
                onClick={handleClick}
            >
                Aplicar
            </Button>
        </>
    ), [inputValue, handleClick, handleChange, blocIdx]);

    return (
        <Popover
            isMoveApplied={isMoveApplied}
            setIsMoveApplied={setIsMoveApplied}
            setInputValue={setInputValue}
            trigger={trigger}
            bodyForm={bodyForm}
        />
    );
}
